export const EVENT_TYPE_META = {
  meeting: { label: 'Meeting', color: '#3B82F6', bg: 'bg-blue-500/15', text: 'text-blue-400', border: 'border-blue-500/30' },
  event: { label: 'Event', color: '#E63946', bg: 'bg-red-500/15', text: 'text-red-400', border: 'border-red-500/30' },
  training: { label: 'Training', color: '#8B5CF6', bg: 'bg-violet-500/15', text: 'text-violet-400', border: 'border-violet-500/30' },
  leave: { label: 'Leave', color: '#F59E0B', bg: 'bg-amber-500/15', text: 'text-amber-400', border: 'border-amber-500/30' },
  other: { label: 'Other', color: '#64748B', bg: 'bg-slate-500/15', text: 'text-slate-300', border: 'border-slate-500/30' },
};

export const EVENT_TYPES = Object.keys(EVENT_TYPE_META);

export const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

export const addDays = (d, n) => {
  const copy = new Date(d);
  copy.setDate(copy.getDate() + n);
  return copy;
};

export const startOfWeek = (d) => addDays(d, -((d.getDay() + 6) % 7));

export const monthGrid = (year, month) => {
  const first = new Date(year, month, 1);
  const start = startOfWeek(first);
  return Array.from({ length: 42 }, (_, i) => addDays(start, i));
};

export const fmtLong = (dateStr) => {
  const [y, m, d] = dateStr.split('-').map(Number);
  return new Date(y, m - 1, d).toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });
};

export const eventsOnDate = (events, dateStr) => events.filter((e) => {
  const end = e.end_date || e.date;
  return e.date <= dateStr && dateStr <= end;
});
